import ReceiptPayrollExtract from './ReceiptPayrollExtract';

export default ReceiptPayrollExtract;